import extractAulaEditorText from '@core/utils/extractAulaEditorText';
import { appendAndReorderMessages, getMessageById, unique } from './utils';

const fetchMessageReducer = (state, action) => {
  if (action.status !== 'success') return state;
  const { conversationId, message, localId, hasNewerMessages } = action.payload;

  const conversation = state.conversations[conversationId];
  if (!conversation) {
    return state;
  }

  // Always update the conversation's latestMessage with the current timestamp
  // This ensures proper sorting for both group and individual conversations
  if (hasNewerMessages) {
    let preview;
    try {
      preview = extractAulaEditorText(JSON.parse(message.content));
    } catch {
      preview = undefined;
    }

    return {
      ...state,
      conversations: {
        ...state.conversations,
        [conversationId]: {
          ...conversation,
          latestMessage: {
            ...message,
            preview,
            createdAt: message.createdAt || new Date().toISOString(),
          },
        },
      },
    };
  }

  const messages = (conversation.messages || []).map(
    getMessageById(state.messages)
  );

  // We need to filter out messages whose local id already exists in the store.
  // That means the message was originated in the user's local machine and we want
  // to avoid duplicated messages in the conversation.
  const updatedConversationMessages = appendAndReorderMessages(messages, [
    message,
  ]).filter((msg) => msg.id !== localId);
  const updatedConversationMessagesIds = unique(
    updatedConversationMessages.map((m) => m.id)
  );

  const lastMessage =
    updatedConversationMessages[updatedConversationMessages.length - 1];

  const newMessages = {
    ...state.messages,
    [message.id]: message,
  };
  delete newMessages[localId];

  let preview;
  try {
    preview = extractAulaEditorText(JSON.parse(message.content));
  } catch {
    preview = undefined;
  }

  // Ensure the lastMessage has a current timestamp for proper sorting
  const updatedLastMessage = {
    ...lastMessage,
    preview,
    createdAt: lastMessage.createdAt || new Date().toISOString(),
  };

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        latestMessage: updatedLastMessage,
        messages: updatedConversationMessagesIds,
      },
    },
    messages: newMessages,
  };
};

export default fetchMessageReducer;
